import axiosInstance from "./axios";
import { SUBSCRIPTION_KEY } from "./storageKeys";

export const landingPageRegistration = async (data) => {
  try {
    const response = await axiosInstance.post("/dashboard/lp", {
      name: data.name,
      email: data.email,
      phone: data.whatsapp,
      url: typeof window !== "undefined" ? window.location.href : undefined,
      additionalParams: { event: SUBSCRIPTION_KEY },
    });

    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
};
